module.exports = __webpack_public_path__ + "img/img-12.b83f8ad2.png";